export default __webpack_public_path__ + "static/media/no-image.9053c863.svg";